export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fbcaf789a87edf1c1e5f75c7a9935c3b20f61c80e&name=fetchTypeahead!'